import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const inventoryDetailsBaseUrl = `${apiUrl}/inventoryDetails`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const inventoryDetailsApi = {
  getAll: (request) => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${inventoryDetailsBaseUrl}?${query}`);
  },
  getByProduct: (productId) => {
    return Axios.get(`${inventoryDetailsBaseUrl}/byproduct/${productId}`, config);
  },
  count: id => {
    return Axios.get(`${inventoryDetailsBaseUrl}/count?${id}`, config);
  },
  updateCostCenter: (inventoryItemId, costCenterId) => {
    return Axios.put(`${inventoryDetailsBaseUrl}/item/${inventoryItemId}/costcenter`, { costCenterId }, config);
  },
};
